import { createStore } from 'vuex'
import grading from './modules/grading';
import learnerCentralStore from './modules/learnerCentralStore';
import lti from './modules/lti';
import createPersistedState from "vuex-persistedstate";

const debug = process.env.NODE_ENV !== 'production'

export default createStore({
  modules: {
    grading,
    learnerCentralStore,
    lti
  },
  strict: debug,
  plugins: [createPersistedState()],
})